
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useIsMobile } from "@/hooks/use-mobile";

export function MonitoringDisclosure() {
  const isMobile = useIsMobile();
  
  return (
    <div className={`${isMobile ? 'mb-4' : 'mb-6'}`}>
      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="what-monitored">
          <AccordionTrigger className="text-sm sm:text-base py-2">What is being monitored?</AccordionTrigger>
          <AccordionContent>
            <ul className="list-disc pl-5 space-y-1 text-xs sm:text-sm text-muted-foreground">
              <li>Browser tab switches and window focus</li>
              <li>Device information for session verification</li>
              <li>AI-generated content detection</li>
            </ul>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="data-usage">
          <AccordionTrigger className="text-sm sm:text-base py-2">How is this data used?</AccordionTrigger>
          <AccordionContent>
            <div className="space-y-1 text-xs sm:text-sm text-muted-foreground">
              <p>The collected data is used to:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Verify the authenticity of test responses</li>
                <li>Prevent unauthorized assistance or cheating</li>
                <li>Ensure fair assessment for all candidates</li>
              </ul>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
